import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";

import { PlatformHeader } from "./PlatformHeader";
import { Sidebar } from "./Sidebar";
import { ToastRegion } from "./Toast";
import { Topbar } from "./Topbar";

/**
 * 应用骨架（specs/07 §5）：
 *
 * platform-header (68px)
 * └─ app-shell (grid 232px | 1fr)
 *    ├─ sidebar
 *    └─ workspace
 *       ├─ topbar (72px)
 *       └─ main#workspace-main
 *
 * 观众侧视图隐藏 sidebar 与 topbar（`body.is-platform-view`），
 * 工作台视图切换回浅色主题（`body.is-studio-view`）——两者都由原型的 CSS 控制。
 */
export function AppLayout() {
  const location = useLocation();
  const isStudio = location.pathname.startsWith("/studio");
  const view = location.pathname.split("/").filter(Boolean)[1] ?? "overview";

  useEffect(() => {
    document.body.classList.toggle("is-studio-view", isStudio);
    document.body.classList.toggle("is-platform-view", !isStudio);
  }, [isStudio]);

  return (
    <>
      <a className="skip-link" href="#workspace-main">
        跳到主要内容
      </a>

      <PlatformHeader />

      <div className="app-shell">
        {isStudio ? <Sidebar /> : null}

        <section className="workspace">
          {isStudio ? <Topbar view={view} /> : null}
          <main id="workspace-main" tabIndex={-1}>
            <div id="view-root" aria-live="polite" className="view-enter">
              <Outlet />
            </div>
          </main>
        </section>
      </div>

      <ToastRegion />
    </>
  );
}
